'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useSuspensions, useValidators } from '@personly/libs-providers';
import { Input } from '@personly/libs-widgets';
import { useEmails } from '@/providers/emails';
interface Props {
  id: string;
}
const TicketEmail = t0 => {
  const $ = _c(8);
  const {
    id
  } = t0;
  const {
    email,
    setEmail
  } = useEmails();
  const {
    validate
  } = useValidators();
  const {
    suspended
  } = useSuspensions();
  const blocked = suspended("CREATE_TICKET") === "STARTED";
  let t1;
  if ($[0] !== setEmail) {
    t1 = e => setEmail(e.target.value);
    $[0] = setEmail;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = email.length > 0 && !validate("EMAIL", email);
  let t3;
  if ($[2] !== blocked || $[3] !== email || $[4] !== id || $[5] !== t1 || $[6] !== t2) {
    t3 = <Input id={id} type="email" value={email} disabled={blocked} onChange={t1} invalid={t2} />;
    $[2] = blocked;
    $[3] = email;
    $[4] = id;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default TicketEmail;